"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.learning = exports.list = exports.patch = exports.post = void 0;
const createApi_1 = require("../../../helpers/createApi");
const types_1 = require("./types");
const post = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/learnings`)
        .post(payload)
        .then((data) => types_1.LearningSchema.parse(data));
};
exports.post = post;
const patch = (caller) => ({ accountId, payload }) => {
    const { learning_id, ...rest } = payload;
    return caller(`/accounts/${accountId}/learnings/${payload.learning_id}`)
        .patch(rest)
        .then((data) => types_1.LearningSchema.parse(data));
};
exports.patch = patch;
const list = (caller) => ({ accountId, _page, _max_per_page }) => {
    const url = `/accounts/${accountId}/learnings`;
    return caller(url)
        .get({
        _page,
        _max_per_page,
    })
        .then(types_1.LearningListReturnSchema.parse);
};
exports.list = list;
const get = (caller) => ({ accountId, learningId }) => {
    return caller(`/accounts/${accountId}/learnings/${learningId}`).get().then(types_1.LearningSchema.parse);
};
exports.learning = (0, createApi_1.createAPIFactory)({
    post: exports.post,
    patch: exports.patch,
    list: exports.list,
    get,
});
//# sourceMappingURL=api.js.map